import React from 'react';
import { FaSortAmountUp, FaSortAmountDown } from 'react-icons/fa';

function SortControls({ sortBy, sortOrder, onSortByChange, onSortOrderChange }) {
  return (
    <div className="sort-controls">
      <select 
        value={sortBy} 
        onChange={(e) => onSortByChange(e.target.value)}
        className="sort-select"
        title="Sort by"
      >
        <option value="updated">Sort by: Last Updated</option>
        <option value="created">Sort by: Created Date</option>
        <option value="title">Sort by: Title</option>
      </select>
      <button
        className="sort-order-button"
        onClick={onSortOrderChange}
        title={sortOrder === 'asc' ? 'Sort Ascending' : 'Sort Descending'}
      >
        {sortOrder === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
      </button>
    </div>
  );
}

export default SortControls; 